<template>
  <nav class="navbar" :class="{ 'navbar-scrolled': isScrolled }">
    <div class="nav-content">
      <div class="nav-left">
        <router-link to="/" class="logo">
          <!-- <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%234CAF50'%3E%3Cpath d='M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z'/%3E%3C/svg%3E" alt="图片库" class="logo-img"> -->
          <img src="/cover.png" class="logo-img" />
        </router-link>
      </div>

      <div class="search-container">
        <div class="search-box">
          <input type="text" placeholder="搜索图片..." v-model="searchQuery" @keyup.enter="handleSearch">
          <button class="search-btn" @click="handleSearch">
            <i class="fas fa-search"></i>
          </button>
        </div>
        <div class="search-suggestions" :class="{ 'hide-suggestions': isScrolled }">
          推荐搜索：
          <a href="#" class="suggestion-item" @click.prevent="searchKeyword(item)" v-for="item in tags" :key="item">{{ item }}</a>
        </div>
      </div>

      <div class="nav-right">
        <div class="explore-menu">
          <span class="explore-btn">
            <router-link to="/ai-creation">
              <i class="fas fa-magic"></i>
              AI创作平台
            </router-link>
          </span>
          <span class="explore-btn">
            <router-link to="/photos">
              <i class="fas fa-images"></i>
              全部图片
            </router-link>
            <!-- <i class="fas fa-chevron-down"></i> -->
          </span>
          <!-- <div class="dropdown-menu explore-dropdown">
            <router-link to="/">
              <i class="fas fa-home"></i>
              首页
            </router-link>
            <router-link to="/photos">
              <i class="fas fa-images"></i>
              图片
            </router-link>
            <router-link to="/about">
              <i class="fas fa-info-circle"></i>
              关于
            </router-link>
          </div> -->
        </div>
        <div class="nav-auth" v-if="!isLoggedIn">
          <button class="login-btn" @click="$router.push('/login')">登录</button>
          <button class="signup-btn" @click="$router.push('/register')">注册</button>
        </div>
        <div v-else class="user-menu" @mouseover="handleUserMenuHover(true)" @mouseleave="handleUserMenuHover(false)"
          @click="handleUserMenuClick">
          <div class="avatar-wrapper">
            <img :src="userAvatar || '/default-avatar.png'" :alt="userName" class="user-avatar" v-if="userAvatar">
            <i class="fas fa-user-circle" style="color: cornflowerblue; font-size: 30px;" v-else></i>
            <span class="username">{{ userName }}</span>
            <i class="fas fa-chevron-down"></i>
          </div>
          <div class="dropdown-menu user-dropdown" v-show="showDropdown">
            <a :href="designPageUrl()" class="menu-item" target="_blank" rel="noopener noreferrer" v-if="functions.indexOf('designToolUsage') >= 0">
              <i class="fas fa-infinity"></i>
              <span style="color:orangered;">我要设计</span>
            </a>
            <div class="user-vip-info">
              <template v-if="userVipType">
                <i class="fas fa-crown" style="color: #FFD700;"></i>
                <span v-if="userVipType == 1">普通会员</span>
                <span v-if="userVipType == 2">高级会员</span>
                <span v-if="userVipType == 3">PLUS会员</span>
              </template>
              <template v-else>
                <router-link to="/membership" class="menu-item vip-upgrade">
                  <i class="fas fa-crown"></i>
                  开通会员
                </router-link>
              </template>
            </div>
            <p v-if="userVipType && userVipType > 0" style="font-size: 14px; text-align: center;">({{ userVipExpireTime
              }})</p>
            <p style="font-size: 14px; text-align: center; color: #4caf50;">虚拟豆余额: {{ coinBalance
              }} <span class="recharge-btn-inline" @click.stop="handleRecharge">充值</span></p>
            <div class="menu-divider"></div>
            <div class="mobile-explore-menu" v-if="isMobile">
              <router-link to="/" class="menu-item">
                <i class="fas fa-home"></i>
                首页
              </router-link>
              <router-link to="/photos" class="menu-item">
                <i class="fas fa-images"></i>
                图片
              </router-link>
              <div class="menu-divider"></div>
            </div>

            <router-link to="/my/photos" class="menu-item">
              <i class="fas fa-images"></i>
              我的图片
            </router-link>
            <router-link to="/my/favorites" class="menu-item">
              <i class="fas fa-heart"></i>
              我的收藏
            </router-link>
            <router-link to="/upload" class="menu-item">
              <i class="fas fa-upload"></i>
              上传图片
            </router-link>
            <div class="menu-divider"></div>
            <div class="menu-item" @click="handleLogout">
              <i class="fas fa-sign-out-alt"></i>
              退出登录
            </div>
          </div>
        </div>
      </div>
    </div>
    <recharge-dialog :visible="showRechargeDialog" @close="showRechargeDialog = false" />
    </nav>
</template>

<script>
import { eventBus } from '@/utils/eventBus'
import { request } from '@/utils/request'
import RechargeDialog from '@/components/RechargeDialog.vue'

export default {
  name: 'Navbar',
  components: {
    RechargeDialog
  },
  data() {
    return {
      searchQuery: '',
      isScrolled: false,
      isLoggedIn: false,
      showDropdown: false,
      userAvatar: '',
      userName: '',
      isMobile: false,
      tags: ['球体', '纤维', '凝胶', '纳米材料', '多孔材料', '箭头', '细胞', '电化学类'],
      functions: [],
      showRechargeDialog: false,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    this.checkLoginStatus()
    eventBus.$on('login-success', this.checkLoginStatus)
    eventBus.$on('logout', this.handleLogout)
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    eventBus.$off('login-success', this.checkLoginStatus)
    eventBus.$off('logout', this.handleLogout)
    window.removeEventListener('resize', this.checkMobile)
  },
  methods: {
    handleSearch() {
      if (!this.searchQuery.trim()) return
      this.$router.push({
        path: '/photos',
        query: { keyword: this.searchQuery.trim() }
      })
      this.searchQuery = ''
    },
    searchKeyword(keyword) {
      this.searchQuery = keyword
      this.handleSearch()
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 100
    },
    async checkLoginStatus() {
      const token = localStorage.getItem('token')
      this.isLoggedIn = !!token
      if (this.isLoggedIn) {
        // 从localStorage获取用户信息
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
        this.userAvatar = userInfo.avatar || ''
        this.userName = userInfo.nickname || '用户'

        const statusResponse = await request(`/api/auth/self`);
        if (statusResponse.ok) {
          this.userVipType = statusResponse.data.vipType || ''
          this.userVipExpireTime = statusResponse.data.vipExpireTime || ''
          this.functions = statusResponse.data.functions || []
          this.coinBalance = statusResponse.data.coinBalance || 0
        }
      }
    },
    handleLogout() {
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      this.isLoggedIn = false
      this.userAvatar = ''
      this.userName = ''
      this.$router.push('/login')
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 768
    },
    handleUserMenuHover(show) {
      if (!this.isMobile) {
        this.showDropdown = show
      }
    },
    handleUserMenuClick() {
      if (this.isMobile) {
        this.showDropdown = !this.showDropdown
      }
    },
    designPageUrl() {
      const token = localStorage.getItem('token')
      const userInfo = localStorage.getItem('userInfo')
      if (!token) {
        this.router.push('/login');
        return
      }

      const url = new URL('http://canvas.keyanzz.com');
      // const url = new URL('http://localhost:3001');

      url.searchParams.set('lng', 'zh-CN');

      if (token) {
        url.searchParams.set('token', token);
      }

      if (userInfo) {
        url.searchParams.set('userId', userInfo.id || '');
        url.searchParams.set('username', userInfo.username || '');
      }

      return url.toString();
    },
    handleRecharge() {
      this.showRechargeDialog = true
    },
  }
}
</script>

<style scoped>
.navbar {
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1001;
  height: 80px;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
}

.navbar-scrolled {
  height: 60px;
}

.navbar-scrolled .nav-content {
  padding-top: 0;
  padding-bottom: 0;
}

.navbar-scrolled .logo {
  font-size: 1.3em;
}

.navbar-scrolled .search-box {
  transform: scale(0.9);
}

.navbar-scrolled .nav-auth button {
  padding: 6px 20px;
  font-size: 14px;
}

.navbar-scrolled .explore-btn {
  font-size: 14px;
  padding: 6px 10px;
}

.nav-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  transition: all 0.3s ease;
}

.nav-left {
  flex: 0 0 150px;
}

.logo {
  font-size: 1.5em;
  font-weight: bold;
  color: #333;
  text-decoration: none;
  white-space: nowrap;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 10px;
}

.logo-img {
  height: 60px;
  width: auto;
}

.navbar-scrolled .logo-img {
  height: 28px;
}

.search-container {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 500px;
}

.search-box {
  display: flex;
  align-items: center;
  border: 1px solid #ddd;
  border-radius: 20px;
  overflow: hidden;
  transition: all 0.3s ease;
  transform-origin: center center;
}

.search-box input {
  flex: 1;
  padding: 8px 12px;
  padding-left: 20px;
  border: none;
  outline: none;
  font-size: 14px;
}

.search-btn {
  padding: 8px 16px;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
}

.search-btn:hover {
  color: #4CAF50;
}

.search-suggestions {
  margin-top: 6px;
  font-size: 12px;
  color: #666;
  text-decoration: center;
  opacity: 1;
  visibility: visible;
  transition: all 0.3s ease;
  height: auto;
  transform: translateY(0);
}

.suggestion-item {
  margin-left: 8px;
  color: #4CAF50;
  text-decoration: none;
  position: relative;
  cursor: pointer;
}

.suggestion-item:hover {
  text-decoration: underline;
}

.suggestion-item:not(:last-child)::after {
  content: "·";
  color: #666;
  margin-left: 8px;
  text-decoration: none;
  pointer-events: none;
}

.hide-suggestions {
  opacity: 0;
  visibility: hidden;
  height: 0;
  transform: translateY(-10px);
}

.nav-right {
  display: flex;
  align-items: center;
  gap: 20px;
  flex: 0 0 auto;
  justify-content: flex-end;
}

.explore-menu {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
}

.explore-btn {
  padding: 8px 12px;
  cursor: pointer;
  color: #666;
  font-size: 15px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 4px;
}

.explore-btn i {
  font-size: 12px;
  margin-top: 2px;
  transition: transform 0.3s ease;
}

.explore-menu:hover .explore-btn i {
  transform: rotate(180deg);
}

.explore-btn a {
  text-decoration: none;
  color: #4CAF50;
}

.explore-btn a i {
  font-size: 14px;
  width: 16px;
  text-align: center;
}

.explore-btn a:hover {
  background: #f5f5f5;
  color: #4CAF50;
}

.dropdown-menu.explore-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 8px 0;
  min-width: 120px;
  transform-origin: top center;
  transition: all 0.3s ease;
  opacity: 0;
  transform: translateY(-10px) scaleY(0);
  pointer-events: none;
}

.explore-menu:hover .explore-dropdown {
  opacity: 1;
  transform: translateY(0) scaleY(1);
  pointer-events: auto;
}

.dropdown-menu a {
  display: block;
  padding: 8px 16px;
  color: #666;
  text-decoration: none;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 8px;
}

.dropdown-menu a i {
  font-size: 14px;
  width: 16px;
  text-align: center;
}

.dropdown-menu a:hover {
  background: #f5f5f5;
  color: #4CAF50;
}

.nav-auth {
  display: flex;
  gap: 10px;
}

.nav-auth button {
  padding: 8px 24px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 15px;
  white-space: nowrap;
  transition: all 0.3s ease;
}

.login-btn {
  background: transparent;
  border: 1px solid #4CAF50;
  color: #4CAF50;
}

.signup-btn {
  background: #4CAF50;
  border: none;
  color: white;
}

.user-menu {
  position: relative;
}

.avatar-wrapper {
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #4CAF50;
}

.username {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.avatar-wrapper i {
  font-size: 12px;
  color: #666;
  margin-left: 4px;
  transition: transform 0.3s;
}

.user-menu:hover .avatar-wrapper i {
  transform: rotate(180deg);
}

.dropdown-menu.user-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 8px 0;
  min-width: 160px;
  margin-top: 0;
  z-index: 1000;
}

.user-menu::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  height: 12px;
}

.menu-divider {
  height: 1px;
  background: #eee;
  margin: 4px 0;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  color: #666;
  text-decoration: none;
  transition: background 0.3s;
  cursor: pointer;
}

.menu-item:hover {
  background: #f5f5f5;
  color: #4CAF50;
}

.menu-item:last-child:hover {
  color: #f44336;
  /* 退出登录按钮hover时显示红色 */
}

.menu-item i {
  font-size: 14px;
  width: 16px;
  text-align: center;
}

@media (max-width: 768px) {
  .nav-content {
    padding: 0 12px;
    position: relative;
  }

  .nav-left {
    flex: 0 0 auto;
  }

  .logo {
    font-size: 1.2em;
  }

  .logo-img {
    height: 24px;
  }

  .search-container {
    position: static;
    transform: none;
    width: auto;
    flex: 1;
    margin: 0 8px;
  }

  .search-box {
    width: 100%;
  }

  .search-box input {
    padding: 6px 12px;
    font-size: 13px;
  }

  .search-btn {
    padding: 6px 12px;
  }

  .search-suggestions {
    position: absolute;
    left: 12px;
    right: 12px;
    text-align: left;
  }

  .nav-right {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .explore-menu {
    display: block;
  }

  .explore-btn {
    padding: 6px 8px;
    font-size: 13px;
  }

  .explore-btn a {
    display: flex;
    align-items: center;
    gap: 4px;
    white-space: nowrap;
  }

  .explore-btn a i {
    font-size: 14px;
  }

  .nav-auth {
    display: flex;
    gap: 6px;
  }

  .nav-auth button {
    padding: 6px 10px;
    font-size: 13px;
  }

  .login-btn {
    display: block;
  }
}

@media (max-width: 480px) {
  .search-container {
    margin: 0 6px;
  }

  .nav-right {
    gap: 6px;
  }

  .explore-btn {
    padding: 6px 6px;
  }

  .nav-auth button {
    padding: 6px 8px;
  }
}

.user-vip-info {
  padding: 10px 15px;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.vip-upgrade {
  color: #FF7043 !important;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
}

.vip-upgrade:hover {
  background-color: #FFF3E0;
}

.vip-upgrade i {
  color: #FF7043;
}

.recharge-btn-inline {
  display: inline-block;
  padding: 2px 8px;
  margin-left: 8px;
  background: #FF7043;
  color: white !important;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: background 0.3s;
}

.recharge-btn-inline:hover {
  background: #F4511E;
}
</style>
